import * as THREE from 'three'
import HALO from 'vanta/src/vanta.halo'

VANTA.HALO({
    el: "#net",
    mouseControls: false,
    touchControls: false,
    gyroControls: false,
    color: 0xfd3995,
    size: 1.6,
    scale: 0.75,
    xOffset: 0.22,
    scaleMobile: 0.50,
    THREE: THREE
});